export enum SetOpportunityFormState {
  Loading,
  NoSalesForceAccount,
  OpportunitiesFound,
  OpportunitiesNotFound,
}
